export function onOutsideClickDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: onOutsideClickDirectiveCtrl,
	};
}

export class onOutsideClickDirectiveCtrl {
	constructor($scope, $element, $attrs, $timeout) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		this.element = $element[0];
		this.$attrs = $attrs;
		this.$timeout = $timeout;
		// self bind some functions
		this.removeListener = this.removeListener.bind(this);
		this.handleClick = this.handleClick.bind(this);
		// setup
		this.addListener();
		this.$scope.$on('$destroy', this.removeListener);
	}

	/**
	 * Listen on the document; all click events will bubble up
	 */
	addListener() {
		document.addEventListener('click', this.handleClick);
	}

	/**
	 * Remove listeners from the document
	 */
	removeListener() {
		document.removeEventListener('click', this.handleClick);
	}

	/**
	 * determine if this click is a child of our host element
	 * @param {MouseEvent} evt  The click event
	 */
	handleClick(evt) {
		let node = evt.target;
		while (node) {
			if (node === this.element) {
				return;
			}
			node = node.parentNode;
		}
		this.fireHandler(evt);
	}

	/**
	 * Evaluate the sh-on-outside-click expression
	 * @param {MouseEvent} $event  The click event
	 */
	fireHandler($event) {
		this.$scope.$eval(this.$attrs.shOnOutsideClick, { $event });
		this.$timeout(() => {});
	}
}
